import React from 'react';
import './FeatureCard.scss';

interface FeatureCardProps {
  icon: React.ReactNode;
  title: string;
  description?: string;
  color: string;
}

const FeatureCard: React.FC<FeatureCardProps> = ({ icon, title, description, color }) => {
  return (
    <div className="feature-card">
      <div className="feature-icon" style={{ backgroundColor: color }}>
        {icon}
      </div>
      <h3 className="feature-title">{title}</h3>
      {description && <p className="feature-description">{description}</p>}
    </div>
  );
};

export default FeatureCard;
